"use client";

import { iconMap } from "@/lib/icon-map";
import { Globe } from "lucide-react";
import dynamic from "next/dynamic";
import { memo, Suspense } from "react";

const DefaultIcon = () => <Globe />;

const FallbackIcon = () => <DefaultIcon />;
FallbackIcon.displayName = "FallbackIcon";

type IconProps = {
  name: string;
  className?: string;
  width?: number;
};

const Loader = () => {
  return (
    <span className="relative flex size-4 align-middle items-center justify-center">
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-75"></span>
      <span className="relative inline-flex size-4 rounded-full bg-sky-500"></span>
    </span>
  );
};

const IconMemo = ({ name, ...other }: IconProps) => {
  const importer = iconMap[name as keyof typeof iconMap];
  const IconComponent = dynamic(
    importer || (() => Promise.resolve(FallbackIcon)),
    {
      loading: () => <Loader />,
      ssr: false,
    }
  );
  return (
    <Suspense fallback={<span className="inline-block w-6 h-6 bg-gray-200" />}>
      <IconComponent {...other} />
    </Suspense>
  );
};

const Icon = memo(IconMemo);
Icon.displayName = "Icon";
export default Icon;
